export const showHideLoader = (show = false) => {
  let loader = document.getElementById("cover-spin");
  if (loader) loader.style.display = show ? "block" : "";
};

export const processImage = (file, message, setImage) => {
  if (file.size > 20971520) {
    message.innerHTML = "File size cannot be greater than 20MB";
    return;
  }
  const reader = new FileReader();
  reader.readAsDataURL(file);

  reader.onload = function (e) {
    const img = new Image();
    img.src = e.target.result;
    img.onload = function () {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const MAX_WIDTH = 800;
      const MAX_HEIGHT = 800;
      let width = img.width;
      let height = img.height;
      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }
      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);
      canvas.toBlob(
        function (blob) {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onload = function () {
            setImage(reader.result);
          };
        },
        "image/jpeg",
        0.8
      );
    };
  };
};

export const handleContent = (type, content) =>
  type == "1"
    ? `<p>${content}</p>`
    : `<ul>${content
        .split("|")
        .map((word) => `<li>${word.trim()}</li>`)
        .join("")}</ul>`;

export const convertToHindiNumerals = (number) => {
  const hindiNumerals = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];
  return number
    .toString()
    .split("")
    .map((digit) => hindiNumerals[parseInt(digit)])
    .join("");
};

export const convertToNumerals = (number) => {
  const numerals = {
    "०": 0,
    "१": 1,
    "२": 2,
    "३": 3,
    "४": 4,
    "५": 5,
    "६": 6,
    "७": 7,
    "८": 8,
    "९": 9,
  };
  let result = number
    .split("")
    .map((digit) => numerals[digit])
    .join("");
  return !isNaN(result) && parseInt(result);
};

export const alignContent = (alignment, heading, image, type, content) => {
  let data = `<span class="headings">${heading}</span>`;
  if (alignment == "1") {
    data += image ? `<img src=${image} style="width: 350px"/>` : "";
    data += handleContent(type, content);
  } else if (alignment == "2") {
    data += image
      ? `<img src=${image} style="float: right;width: 350px"/>`
      : "";
    data += handleContent(type, content);
  } else if (alignment == "3") {
  }
  return data;
};
